import { useTranslation } from 'react-i18next';

export default function AccessSection() {
  const { t } = useTranslation();

  return (
    <section id="access" className="py-24 bg-gradient-to-b from-[#f5e6d3] to-[#fff8f0] relative overflow-hidden">
      {/* 昭和レトロ背景テクスチャ */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* タイトル - 昭和旅行案内風 */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-0.5 w-12 bg-gradient-to-r from-transparent to-[#c1502e]" />
            <span className="text-xs tracking-[0.4em] text-[#8b4513] uppercase font-bold px-4 py-1.5 bg-[#fff8f0] border-2 border-[#c1502e] rounded-sm shadow-sm">Access Guide</span>
            <div className="h-0.5 w-12 bg-gradient-to-l from-transparent to-[#c1502e]" />
          </div>

          <h2 className="text-4xl sm:text-5xl font-bold text-[#2c1810] mb-6 tracking-tight" style={{ 
            fontFamily: "'Noto Serif JP', serif",
            textShadow: '2px 2px 0px rgba(193, 80, 46, 0.1)'
          }}>
            羽田空港から25分
            <br />
            <span className="text-[#c1502e]">Haneda Airport Access</span>
          </h2>
          
          <p className="text-lg text-[#5c4033] max-w-2xl mx-auto leading-relaxed">
            昭和の面影残る馬込の静かな住宅街
            <br className="hidden sm:block" />
            Conveniently located in retro Magome neighborhood
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {/* 地図 - レトロフレーム */}
          <div className="space-y-6">
            {/* Googleマップ - 昭和風フレーム */}
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-br from-[#8b4513] to-[#c1502e] rounded-lg opacity-20"></div>
              <div className="relative rounded-lg overflow-hidden shadow-2xl w-full h-[400px] border-4 border-[#8b4513]" style={{
                boxShadow: '0 8px 16px rgba(139, 69, 19, 0.3), inset 0 0 0 2px rgba(255, 248, 240, 0.5)'
              }}>
                <iframe
                  src="https://maps.google.com/maps?q=東京都大田区東馬込1-12-12&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Magome Kominka Location Map"
                ></iframe>
              </div>
            </div>

            {/* 住所カード - 昭和風 */}
            <div className="bg-gradient-to-br from-[#fff8f0] to-[#fef3e2] rounded-lg p-6 shadow-lg border-2 border-[#d4a574] relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#c1502e] opacity-5 rounded-full -mr-16 -mt-16"></div>
              <div className="flex items-start gap-4 relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-[#c1502e] text-white rounded-lg flex-shrink-0 shadow-md">
                  <i className="ri-map-pin-2-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xs font-bold text-[#8b4513] uppercase tracking-wider mb-2 border-b border-[#d4a574] pb-1 inline-block">
                    所在地 / Address
                  </h3>
                  <p className="text-lg font-bold text-[#2c1810] mb-1">東京都大田区東馬込1-12-12</p>
                  <p className="text-sm text-[#5c4033]">1-12-12 Higashi-Magome, Ota-ku, Tokyo 143-0022, Japan</p>
                </div>
              </div>
            </div>
          </div>

          {/* アクセス詳細 - 昭和路線図風 */}
          <div className="space-y-5">
            
            {/* 羽田空港から - レトロポスター風 */}
            <div className="bg-gradient-to-br from-[#fff8f0] to-[#fef3e2] rounded-lg p-6 shadow-lg border-2 border-[#c1502e] hover:border-[#8b4513] transition-all relative overflow-hidden group">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#c1502e] via-[#d4a574] to-[#c1502e]"></div>
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#c1502e] text-white rounded-lg flex-shrink-0 shadow-md group-hover:scale-110 transition-transform">
                  <i className="ri-flight-takeoff-fill text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-[#2c1810] mb-3 flex items-center gap-2">
                    羽田空港より / From Haneda Airport
                  </h3>
                  <div className="space-y-2.5 text-sm text-[#5c4033]">
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-train-fill text-[#c1502e] mt-0.5 text-lg"></i>
                      <span><strong className="text-[#8b4513]">電車:</strong> 京急線で馬込駅まで約25分</span>
                    </p>
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-walk-fill text-[#c1502e] mt-0.5 text-lg"></i>
                      <span><strong className="text-[#8b4513]">徒歩:</strong> 馬込駅から徒歩2分</span>
                    </p>
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-taxi-fill text-[#c1502e] mt-0.5 text-lg"></i>
                      <span><strong className="text-[#8b4513]">タクシー:</strong> 約20分（¥3,000–¥4,000）</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 最寄り駅 */}
            <div className="bg-gradient-to-br from-[#fff8f0] to-[#fef3e2] rounded-lg p-6 shadow-lg border-2 border-[#d4a574] hover:border-[#c1502e] transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#8b4513] text-white rounded-lg flex-shrink-0 shadow-md">
                  <i className="ri-train-fill text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#2c1810] mb-3">
                    最寄り駅 / Nearest Station
                  </h3>
                  <div className="space-y-2 text-sm text-[#5c4033]">
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-map-pin-fill text-[#c1502e] mt-0.5"></i>
                      <span><strong className="text-[#8b4513]">馬込駅</strong> (都営浅草線)</span>
                    </p>
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-walk-fill text-[#c1502e] mt-0.5"></i>
                      <span>駅から徒歩2分 / 2 minutes on foot</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* バス */}
            <div className="bg-gradient-to-br from-[#fff8f0] to-[#fef3e2] rounded-lg p-6 shadow-lg border-2 border-[#d4a574] hover:border-[#c1502e] transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#d4a574] text-white rounded-lg flex-shrink-0 shadow-md">
                  <i className="ri-bus-fill text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#2c1810] mb-3">
                    バス / By Bus
                  </h3>
                  <div className="space-y-2 text-sm text-[#5c4033]">
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-map-pin-fill text-[#c1502e] mt-0.5"></i>
                      <span>「馬込駅前」バス停から徒歩2分</span>
                    </p>
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-bus-fill text-[#c1502e] mt-0.5"></i>
                      <span>都営バス利用可能</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 駐車場 */}
            <div className="bg-gradient-to-br from-[#fff8f0] to-[#fef3e2] rounded-lg p-6 shadow-lg border-2 border-[#d4a574] hover:border-[#c1502e] transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#8b6f47] text-white rounded-lg flex-shrink-0 shadow-md">
                  <i className="ri-parking-box-fill text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#2c1810] mb-3">
                    駐車場 / Parking
                  </h3>
                  <div className="space-y-2 text-sm text-[#5c4033]">
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-information-fill text-[#c1502e] mt-0.5"></i>
                      <span>近隣にコインパーキングあり</span>
                    </p>
                    <p className="flex items-start gap-2 bg-white/60 p-2 rounded">
                      <i className="ri-phone-fill text-[#c1502e] mt-0.5"></i>
                      <span>お車でお越しの際はご連絡ください</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Mapsボタン - 昭和レトロボタン */}
            <a
              href="https://www.google.com/maps/search/?api=1&query=東京都大田区東馬込1-12-12"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center justify-center gap-3 w-full px-6 py-4 bg-[#c1502e] hover:bg-[#8b4513] text-white rounded-lg text-base font-bold transition-all hover:scale-105 shadow-lg border-2 border-[#8b4513] whitespace-nowrap"
              style={{
                boxShadow: '0 4px 0 #8b4513, 0 8px 16px rgba(139, 69, 19, 0.3)'
              }}
            >
              <i className="ri-map-2-fill text-xl"></i>
              Google Mapsで開く / Open in Google Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}